import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../shared/firebase';

export default function BishopMessage({ onSelectSection }) {
  const [bishopData, setBishopData] = useState({
    name: '',
    img_url: ''
  });

  useEffect(() => {
    let isMounted = true;
    async function fetchBishop() {
      try {
        const collectionsToTry = ['bishop', 'priest', 'presbyter', 'leadership'];
        for (const colName of collectionsToTry) {
          const snap = await getDocs(collection(db, colName)).catch(() => null);
          if (snap && !snap.empty) {
            const doc = snap.docs[0].data();
            if (isMounted && doc) {
              setBishopData({
                name: doc.name || doc.bishop_name || doc.title || 'Rt. Rev. Dr. Royce Manoj Victor',
                img_url: doc.img_url || doc.image || doc.img || doc.photoUrl || ''
              });
              break;
            }
          }
        }
      } catch (err) {
        console.error("Error fetching bishop data:", err);
      }
    }
    fetchBishop();
    return () => { isMounted = false; };
  }, []);

  return (
    <section className="py-6 sm:py-8 bg-transparent max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-gradient-to-br from-[#FAF5EF] via-[#FAF7F2] to-[#F5ECE5] rounded-[28px] sm:rounded-[36px] p-6 sm:p-8 md:p-10 border border-[#E8DDD7] shadow-[0_10px_35px_rgba(132,35,67,0.05)] grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-10 items-center text-left">
        
        {/* Left Bishop Portrait */}
        <div className="lg:col-span-4 flex justify-center">
          <div className="w-full max-w-xs sm:max-w-sm rounded-[24px] sm:rounded-[28px] overflow-hidden h-[300px] sm:h-[360px] md:h-[390px] bg-[#FAF6F2] shadow-lg border-[5px] border-white aspect-[4/5]">
            {bishopData.img_url ? (
              <img
                src={bishopData.img_url}
                alt={bishopData.name || "Rt. Rev. Dr. Royce Manoj Victor"}
                className="w-full h-full object-cover object-top hover:scale-103 transition-transform duration-700"
              />
            ) : (
              <div className="w-full h-full bg-[#842343]/10 flex items-center justify-center text-[#842343] font-serif font-bold text-xl">
                {bishopData.name || "Rt. Rev. Dr. Royce Manoj Victor"}
              </div>
            )}
          </div>
        </div>

        {/* Right Pastoral Quote & Title */}
        <div className="lg:col-span-8 space-y-4 sm:space-y-5">
          <div className="inline-flex items-center gap-2 bg-[#842343]/10 text-[#842343] px-3.5 py-1.5 rounded-full text-xs font-bold border border-[#842343]/15">
            <span>Pastoral Message</span>
          </div>

          <blockquote className="font-serif font-bold italic text-[#2D1E24] text-[20px] sm:text-[24px] md:text-[28px] leading-[1.35] tracking-tight relative">
            "But those who hope in the Lord will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint."
          </blockquote>

          <p className="text-[#842343] text-sm sm:text-base font-serif font-extrabold tracking-wide">
            — Isaiah 40:31
          </p>

          <div className="pt-2 border-t border-[#E8DDD7]">
            <h4 className="font-serif font-bold text-xl sm:text-2xl text-[#842343]">
              {bishopData.name || "Rt. Rev. Dr. Royce Manoj Victor"}
            </h4>
            <span className="text-xs sm:text-sm font-sans font-bold uppercase tracking-wider text-[#8A7E79] block mt-1">
              Diocesan Bishop, CSI Diocese of Malabar
            </span>
          </div>

          <div className="pt-2">
            <button
              onClick={() => onSelectSection('bishop')}
              className="bg-[#842343] hover:bg-[#6c1b35] text-white text-xs font-bold py-3 px-6 rounded-xl shadow-xs transition-all duration-300 flex items-center gap-2 cursor-pointer"
            >
              <span>Visit Bishop's Office</span>
              <span>→</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
